import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const MetaRow = ({
  location,
  mutualCount,
}: {
  location?: string;
  mutualCount?: number;
}) => {
  if (!location && !mutualCount) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      {location && (
        <div className="flex items-center gap-1">
          <Icon name="map-pin" size="sm" color="secondary" />
          <Typography
            truncate
            variant="label-xs"
            color="secondary"
            className="max-w-[200px]"
          >
            {location}
          </Typography>
        </div>
      )}
      {!!mutualCount && (
        <div className="flex items-center gap-1">
          <Icon name="people" color="secondary" />
          <Typography variant="label-xs" color="secondary">
            {t("members_directory.mutual_count", { count: mutualCount })}
          </Typography>
        </div>
      )}
    </div>
  );
};
